export const NAME = 'ratingAreaRecalculation'
